export interface Article {
  id: string;
  slug: string;
  title: string;
  excerpt: string;
  content: string[];
  category: string;
  categoryName: string;
  tags: string[];
  image: string;
  date: string;
  readTime: string;
  author: string;
}

export const articles: Article[] = [
  {
    id: 'art-001',
    slug: 'ruhe-youya-rang-jiejie-jieshao-pengyou',
    title: '如何优雅地让姐姐介绍朋友给你认识',
    excerpt: '想要拓展社交圈但不知如何开口？这篇文章教你用最自然的方式，让姐姐成为你最好的社交推荐人。',
    content: [
      '在社交拓展的过程中，家人的朋友圈往往是最容易被忽视却又最宝贵的资源。姐姐作为你最亲近的人之一，她的朋友圈天然就是你的"黄金社交入口"。但问题在于：如何才能优雅地让姐姐愿意帮你介绍朋友，而不显得刻意或冒犯？',
      '首先，你需要建立一个基本认知：姐姐是否愿意介绍朋友给你，取决于她对你社交能力的信任度。如果你在之前的社交场合表现出不成熟或不得体的行为，姐姐自然会有所顾虑。因此，提升自己的社交素养是第一步。',
      '具体操作上，你可以从以下几个层面着手。第一，在日常聊天中自然地表达你对姐姐朋友圈的欣赏和好奇，比如夸赞她某个朋友很有趣、很有见识。这种正面反馈会让姐姐更愿意分享她的社交资源。',
      '第二，创造自然的见面机会。相比直接要求"帮我介绍朋友"，不如邀请姐姐和她的朋友一起参加某个你组织的活动——比如一次周末聚餐、一场展览或者一次户外徒步。在轻松的氛围中，社交关系更容易建立。',
      '第三，让姐姐看到你的价值。当姐姐知道你在某些领域有专长，或者你是一个有趣、可靠的人时，她会更放心地把你介绍给她的朋友，因为这本身就是一种"社交背书"。',
      '第四，学会回馈。社交是双向的。当姐姐帮了你之后，记得表达感谢，也可以在她需要的时候提供你的帮助。这种互惠关系会让你们的社交纽带更加牢固。',
      '最后，保持耐心和真诚。社交关系的建立不是一蹴而就的。让姐姐感受到你的真诚和对他人的尊重，她自然会成为你最有力的社交推荐人。',
    ],
    category: 'jiejie-pengyouquan',
    categoryName: '姐姐的朋友圈拓展',
    tags: ['姐姐的朋友', '朋友圈拓展', '社交技巧', '人际关系'],
    image: 'https://readdy.ai/api/search-image?query=Two%20stylish%20women%20sharing%20a%20warm%20laugh%20at%20a%20sunlit%20outdoor%20cafe%2C%20soft%20natural%20lighting%2C%20warm%20amber%20and%20cream%20tones%2C%20genuine%20connection%20and%20friendship%2C%20editorial%20photography%20style%2C%20clean%20background%2C%20harmonious%20composition%2C%20elegant%20casual%20atmosphere&width=800&height=600&seq=art-elegant-intro&orientation=landscape',
    date: '2026-07-28',
    readTime: '6 分钟',
    author: '姐姐的朋友编辑部',
  },
  {
    id: 'art-002',
    slug: 'jiejie-pengyouquan-huangjin-rukou',
    title: '姐姐的朋友圈：为什么是你最好的社交入口',
    excerpt: '姐姐的朋友圈藏着意想不到的社交资源。了解为什么姐姐的朋友圈比任何其他渠道都更适合你拓展人脉。',
    content: [
      '在当今社会，拓展人脉的渠道有很多——职场社交、兴趣社群、线上平台……但有一种资源长期被低估：姐姐的朋友圈。为什么姐姐的朋友圈是你最好的社交入口？这篇文章为你深度解析。',
      '首先，姐姐的朋友圈具有天然的信任背书。与陌生社交不同，当你通过姐姐认识一个人时，你们之间已经建立了一层"熟人推荐"的关系。这种推荐机制极大地降低了社交信任建立的成本。对方会因为信任你姐姐而给予你更多的善意和耐心。',
      '其次，姐姐的朋友圈往往是优质人群的聚集地。姐姐在生活和工作中积累的朋友，大多经过了时间的筛选，在各自领域有一定成就和见解。通过姐姐，你能够接触到那些在常规社交场合难以遇到的优秀人才。',
      '第三，姐姐的朋友圈覆盖多个领域。姐姐可能有职场上的伙伴、大学时期的闺蜜、兴趣社群的同好……这种多元化的社交网络，让你能够一次性接触到不同圈层的资源，实现真正的"跨圈社交"。',
      '第四，姐姐作为中间人的存在，为你的社交行为提供了天然的保护。在初入一个新圈子时，有姐姐作为你的"社交参照点"，你可以更从容地展示自己，不必担心因为不了解圈子规则而冒犯他人。',
      '最后，与姐姐的朋友交往，本质上是一种情感连接的延伸。这种建立在亲情基础上的社交关系，比纯粹的利益社交更稳定、更持久。',
    ],
    category: 'jiejie-pengyouquan',
    categoryName: '姐姐的朋友圈拓展',
    tags: ['姐姐的朋友', '社交入口', '信任关系', '人脉资源'],
    image: 'https://readdy.ai/api/search-image?query=Elegant%20illustration%20of%20a%20warm%20glowing%20doorway%20opening%20into%20a%20beautiful%20social%20gathering%20scene%2C%20soft%20golden%20and%20amber%20light%20spilling%20through%2C%20people%20silhouettes%20in%20warm%20conversation%2C%20minimalist%20composition%2C%20editorial%20style%2C%20hopeful%20and%20inviting%20atmosphere&width=800&height=600&seq=art-golden-entry&orientation=landscape',
    date: '2026-07-22',
    readTime: '7 分钟',
    author: '姐姐的朋友编辑部',
  },
  {
    id: 'art-003',
    slug: 'cong-jiejie-guimi-dao-nide-guiren',
    title: '从姐姐闺蜜到你的贵人：关系升级指南',
    excerpt: '姐姐的闺蜜可能就是你未来的贵人或合作伙伴。学会如何将姐姐的朋友关系升级为你自己的宝贵人脉。',
    content: [
      '"姐姐的闺蜜"——这个角色在很多人心中是一个亲切但"不可逾越"的存在。但实际上，姐姐的闺蜜完全可能成为你人生中最重要的贵人之一。关键在于：你如何完成从"我姐姐的妹妹"到"独立值得交往的人"的身份转换。',
      '第一步，建立独立的连接点。不要永远以"某某的妹妹"的身份出现。找到你和对方之间的共同兴趣或话题，比如你们都喜欢的书籍、电影、运动，或者对方专业领域里你真正感兴趣的话题。这种基于共同点的连接，是关系升级的基础。',
      '第二步，在合适的时机展示你的独立价值。当姐姐的闺蜜遇到某个你能帮忙解决的问题时，主动提供帮助。这种能力展示不需要刻意炫耀，而是在自然的交往中让对方看到你的专业和可靠性。',
      '第三步，创造"非姐姐在场"的互动机会。当你们的关系已经建立了一定的基础后，可以尝试单独约对方喝咖啡或参加活动。这种独立交往让双方能够摆脱"姐姐在场"的角色限定，建立属于你们自己的关系。',
      '第四步，尊重边界，保持分寸。关系升级不意味着你可以完全脱离姐姐这个纽带。始终保持对姐姐的尊重，让姐姐知道你和她的朋友在交往。透明和尊重是维持这种"三角关系"健康发展的关键。',
      '最后，记住关系的本质是真诚。不要把所有社交都当作功利性的"资源获取"。真正有价值的人脉关系，一定是建立在真诚的欣赏和相互尊重的基础上。',
    ],
    category: 'jiejie-pengyouquan',
    categoryName: '姐姐的朋友圈拓展',
    tags: ['姐姐的朋友', '贵人', '关系升级', '社交策略'],
    image: 'https://readdy.ai/api/search-image?query=Two%20elegant%20women%20walking%20together%20in%20a%20beautiful%20autumn%20park%2C%20warm%20sunlight%20filtering%20through%20trees%2C%20genuine%20conversation%20and%20connection%2C%20soft%20amber%20and%20terracotta%20tones%2C%20editorial%20photography%2C%20natural%20and%20organic%20composition%2C%20uplifting%20atmosphere&width=800&height=600&seq=art-guimi-guiren&orientation=landscape',
    date: '2026-07-15',
    readTime: '6 分钟',
    author: '姐姐的朋友编辑部',
  },
  {
    id: 'art-004',
    slug: 'kuajuan-shejiao-wuge-faze',
    title: '跨圈社交的5个黄金法则',
    excerpt: '想要在不同圈层之间游刃有余？掌握这5个黄金法则，让你在任何圈子都能快速找到自己的位置。',
    content: [
      '跨圈社交是现代社交中最高阶的能力之一。无论是从职场圈切换到兴趣圈，还是从老友圈进入新圈子，能够自如地在不同圈层之间穿梭的人，往往能获得更多的机会和资源。以下是经过验证的5个跨圈社交黄金法则。',
      '法则一：找到"社交公约数"。每个圈子都有自己的语言、文化和价值观。初入一个新圈子时，不要急于展示自己，先观察、倾听，找到这个圈子的"公约数"——那些大家共同关心的话题或价值取向。从这个公约数出发，你的发言才更容易被接受。',
      '法则二：提供独特价值。你能为这个新圈子带来什么？如果你带着"我能贡献什么"的心态进入一个圈子，而不是"我能得到什么"，效果会截然不同。可能是你的专业知识、你的跨领域视角，或者是你能够连接不同圈子的桥梁能力。',
      '法则三：尊重圈子的"入场仪式"。每个圈子都有自己的文化和惯例。有些圈子需要时间才能接纳新人，有些则更开放。尊重这种节奏，不要急于求成。愿意花时间慢慢融入的人，往往能获得更深层次的接纳。',
      '法则四：保持自己的"核心身份"。跨圈社交不意味着你要在不同圈子中扮演完全不同的人。恰恰相反，保持真实、一致的自我，才能在不同圈子中建立持久的信任。人们会被真实的你所吸引，而非一个不断变换面孔的"社交变色龙"。',
      '法则五：建立"圈间桥梁"。最顶级的跨圈社交者，不仅能在不同圈子中自如切换，还能成为连接不同圈子的桥梁。当你能够把A圈子里的资源介绍给B圈子里的朋友时，你的社交价值就不仅仅是个人的，而成为了一个"社交枢纽"。',
    ],
    category: 'kuajuan-shejiao',
    categoryName: '跨圈社交方法',
    tags: ['跨圈社交', '社交法则', '社交方法', '人脉拓展'],
    image: 'https://readdy.ai/api/search-image?query=Elegant%20abstract%20illustration%20of%20five%20overlapping%20translucent%20circles%20in%20warm%20coral%20and%20muted%20sage%20green%20tones%2C%20each%20containing%20different%20abstract%20symbols%2C%20representing%20diverse%20social%20circles%20connecting%2C%20minimalist%20composition%2C%20editorial%20style%2C%20harmonious%20balanced%20design&width=800&height=600&seq=art-cross-circle-rules&orientation=landscape',
    date: '2026-07-10',
    readTime: '8 分钟',
    author: '姐姐的朋友编辑部',
  },
  {
    id: 'art-005',
    slug: 'cong-zhichang-dao-xingqu-shejiao-yueqian',
    title: '从职场圈到兴趣圈的社交跃迁指南',
    excerpt: '职场社交和兴趣社交是两种不同的能力。学会在这两个圈子之间灵活切换，拓展你社交的广度与深度。',
    content: [
      '很多人在职场社交上游刃有余，但一到兴趣社群就手足无措；也有人在朋友圈中如鱼得水，但职场社交却处处碰壁。这两种社交场景的底层逻辑确实不同，但掌握了转换方法，你就能实现"社交跃迁"。',
      '职场社交的核心是"角色驱动"。在职场中，你的身份、职位、专业能力决定了你的社交定位。这种社交往往围绕工作目标展开，关系建立在"协作"和"信任"之上。要提升职场社交能力，关键是建立自己的专业声誉和可靠形象。',
      '兴趣社交则更偏向"共鸣驱动"。在兴趣圈中，共同的爱好和热情是社交的黏合剂。这里没有职级高低，只有对某个领域的共同热爱。要想在兴趣圈中受欢迎，你需要的不是头衔，而是热情、真诚和对这个领域的深入理解。',
      '那么如何在两个圈子之间实现"社交跃迁"呢？首先，识别两个圈子的交界点。很多职场伙伴同时也是某个兴趣的爱好者。从共同的兴趣切入，可以让你在职场上建立更深入的个人关系。',
      '其次，学会把兴趣圈的轻松带入职场。适当的个人化表达和真诚的兴趣分享，可以让你在职场中更有温度，打破纯粹的工作关系壁垒。',
      '最后，把职场中培养的专业素养运用到兴趣圈中。比如你的组织能力、沟通技巧，这些在兴趣圈中同样有价值。当你能够把不同圈子的能力相互迁移时，你的社交能力就实现了质的飞跃。',
    ],
    category: 'kuajuan-shejiao',
    categoryName: '跨圈社交方法',
    tags: ['职场社交', '兴趣社交', '社交跃迁', '跨圈社交'],
    image: 'https://readdy.ai/api/search-image?query=Elegant%20split%20composition%20showing%20a%20professional%20workspace%20on%20one%20side%20transitioning%20to%20a%20warm%20creative%20hobby%20space%20on%20the%20other%2C%20soft%20amber%20and%20cream%20tones%2C%20minimalist%20design%2C%20editorial%20style%2C%20harmonious%20color%20transition%2C%20balanced%20composition&width=800&height=600&seq=art-work-to-hobby&orientation=landscape',
    date: '2026-07-05',
    readTime: '7 分钟',
    author: '姐姐的朋友编辑部',
  },
  {
    id: 'art-006',
    slug: 'changqi-renmai-weihu-sanda-mijue',
    title: '长期人脉维护的三大秘诀',
    excerpt: '认识新朋友容易，维护老朋友难。掌握这三大秘诀，让你的人脉关系历久弥新。',
    content: [
      '很多人把大量精力花在"认识新朋友"上，却忽略了"维护老朋友"的重要性。实际上，人脉的价值在于长期积累和持续维护。以下是长期人脉维护的三大核心秘诀。',
      '秘诀一：建立"不打扰的关注"。人脉维护最忌讳的就是"平时不联系，有事才找人"。要建立一种自然而然的关注方式，比如看到与对方面相关的资讯时顺手转发，不必每次都期待回复。这种"不打扰的关注"让对方感受到你真诚的惦记，而非功利的社交。',
      '秘诀二：创造"互惠时刻"。社交的本质是互惠。但这里的互惠不一定是物质层面的，更多是情感和信息层面的交换。留意对方的需求和困难，在你力所能及的范围内提供帮助。这种善意的积累，会在你需要的时候以意想不到的方式回馈给你。',
      '秘诀三：保持"节奏感"。人脉维护需要节奏，既不能太频繁让人感到压力，也不能太久不联系导致关系淡化。根据关系的亲疏程度，找到适合的互动频率。对于核心人脉，可以保持每月一到两次的互动；对于普通朋友，每季度保持联系就足够。',
      '最后，记住一个关键原则：真诚比技巧更重要。任何社交技巧都建立在真诚的基础上。如果你发自内心地关心一个人，对方一定能感受到。反之，如果只是机械地执行"维护计划"，关系终究会变得空洞。',
    ],
    category: 'renmai-weihu',
    categoryName: '人脉维护技巧',
    tags: ['人脉维护', '长期关系', '社交技巧', '人际关系'],
    image: 'https://readdy.ai/api/search-image?query=Elegant%20close-up%20of%20a%20beautifully%20bound%20journal%20with%20warm%20amber%20light%20falling%20across%20its%20pages%2C%20a%20delicate%20golden%20pen%20beside%20it%2C%20representing%20careful%20relationship%20cultivation%2C%20soft%20cream%20background%2C%20editorial%20still%20life%2C%20calm%20and%20thoughtful%20atmosphere&width=800&height=600&seq=art-network-maintain&orientation=landscape',
    date: '2026-06-28',
    readTime: '6 分钟',
    author: '姐姐的朋友编辑部',
  },
  {
    id: 'art-007',
    slug: 'rang-xin-pengyou-jizhu-ni',
    title: '如何让新朋友记住你：留下深刻印象的艺术',
    excerpt: '在社交场合中，让人记住你比让人认识你难得多。学会这门艺术，让你的每一次社交都有回报。',
    content: [
      '在一个社交活动上认识了十个人，但一周后能被记住的可能只有一两个。这就是社交中的"记忆筛选效应"。如何让自己成为那个被记住的人？',
      '首先，打造一个"记忆锚点"。每个人都应该有一个让别人容易记住的特质——可能是你对某个领域的独特见解，可能是你的幽默感，也可能是你某个令人印象深刻的故事。这个锚点不需要多么宏大，但一定要真实和独特。',
      '其次，学会"深度倾听"。大多数人都在等着自己说话，而不是真正在听对方说什么。当你展现出真正的倾听能力——记住对方的名字、关注对方说的细节、在后续交流中提到这些——你会立刻从人群中脱颖而出。',
      '第三，善用"后续跟进"的技巧。认识新朋友后的24小时内，发一条简短的信息表达很高兴认识对方，并提到你们交谈中的某个具体点。这种及时的、有内容的后续跟进，能让你的印象倍加深。',
      '最后，保持一致性。你不需要在每一场社交中都光芒四射，但需要保持一个稳定的、可预期的个人形象。当人们在不同的场合、从不同的人口中听到对你的类似评价时，你的社交形象就真正建立起来了。',
    ],
    category: 'renmai-weihu',
    categoryName: '人脉维护技巧',
    tags: ['留下印象', '新朋友', '社交技巧', '人际关系'],
    image: 'https://readdy.ai/api/search-image?query=Elegant%20illustration%20of%20a%20single%20warm%20glowing%20figure%20standing%20out%20among%20gentle%20silhouettes%20in%20a%20soft%20social%20gathering%2C%20amber%20and%20cream%20tones%2C%20minimalist%20composition%2C%20editorial%20style%2C%20inspirational%20and%20memorable%20visual%2C%20harmonious%20atmosphere&width=800&height=600&seq=art-memorable&orientation=landscape',
    date: '2026-06-20',
    readTime: '5 分钟',
    author: '姐姐的朋友编辑部',
  },
  {
    id: 'art-008',
    slug: 'shouyin-xiaoying-diyi-yinxiang',
    title: '首因效应：第一印象的心理学原理与实战技巧',
    excerpt: '第一印象在7秒内形成，却能影响后续所有交往。从心理学角度解析首因效应，让你的第一印象加分。',
    content: [
      '心理学研究表明，人们在见面的前7秒内就会形成对一个人的初步判断——这就是"首因效应"。更关键的是，这个第一印象一旦形成，会持续影响后续所有的交往评价。',
      '首因效应的核心机制在于"锚定效应"：大脑倾向于用最早获得的信息作为判断的"锚点"，后续信息都会被这个锚点影响。如果你给人的第一印象是"靠谱"，那么即使后来出现小失误，对方也会倾向于解释为"偶发状况"而非否定你的整体。',
      '那么如何优化你的第一印象呢？首先是外在呈现。这并不意味着你需要穿得多么昂贵，而是"得体"——符合场合的着装、整洁的外表和良好的仪态。研究表明，得体且自信的仪态比昂贵的服装更能给人留下好印象。',
      '其次是语言和非语言的协调。微笑、眼神接触、开放的肢体语言，这些非语言信号比你说的话更容易被对方接收到。确保你的语言和身体语言传达一致的信息。',
      '第三是开场白的质量。一个真诚的、与场景相关的开场白远胜于生硬的套话。最好的开场白往往来自对当下场景的观察和共情。',
      '最后，记住首因效应是可管理的。如果你感觉第一次见面的表现不够理想，不要过度焦虑。及时的、真诚的后续沟通可以在很大程度上修正第一印象带来的偏差。',
    ],
    category: 'shejiao-xinlixue',
    categoryName: '社交心理学',
    tags: ['首因效应', '第一印象', '社交心理学', '人际交往'],
    image: 'https://readdy.ai/api/search-image?query=Elegant%20minimalist%20illustration%20of%20a%20warm%20glowing%20light%20bulb%20moment%20representing%20insight%20and%20first%20impressions%2C%20soft%20amber%20and%20cream%20tones%2C%20clean%20composition%2C%20editorial%20style%2C%20intellectual%20and%20warm%20atmosphere%2C%20sophisticated%20design&width=800&height=600&seq=art-first-impression&orientation=landscape',
    date: '2026-06-15',
    readTime: '5 分钟',
    author: '姐姐的朋友编辑部',
  },
  {
    id: 'art-009',
    slug: 'shejiao-xinren-jianli-xinlixue',
    title: '社交信任建立的心理学路径：从陌生到信赖的四阶段',
    excerpt: '信任不是一瞬间建立的，而是经历了四个心理阶段。了解这个路径，加速你与新朋友之间的信任建立。',
    content: [
      '在社交关系中，信任是最宝贵的资产，也是最难建立的。心理学研究指出，人与人之间的信任建立通常经历四个阶段：安全评估期、试探互动期、价值确认期和深度信任期。',
      '第一阶段：安全评估期。这是双方初次接触的阶段。在这个阶段，人们本能地在评估对方是否"安全"——这个人是否友善？是否值得我投入时间？这个阶段的关键是展现真诚和一致性，不要过度热情也不要过度冷漠。',
      '第二阶段：试探互动期。当安全评估通过后，双方开始进行更多互动。这个阶段的特点是"试探性"——双方都在测试彼此的价值匹配度和相处舒适度。在这个阶段，适度的自我暴露（分享一些个人的真实想法或经历）可以加速信任的建立。',
      '第三阶段：价值确认期。当双方发现彼此确实有互补的价值时，关系进入确认期。这个阶段需要的是"承诺一致性"——你的言行一致、你的承诺兑现，这些都会强化对方对你的信任。',
      '第四阶段：深度信任期。这是信任关系的高阶阶段。在这个阶段，双方可以在不完美的情况下依然保持信任。达到这个阶段的关系，往往能经受住时间和冲突的考验。',
      '了解这个路径后，你可以更有针对性地调整自己的社交策略，在不同阶段采取不同的互动方式，加速信任的建立。',
    ],
    category: 'shejiao-xinlixue',
    categoryName: '社交心理学',
    tags: ['信任建立', '社交心理学', '人际关系', '心理学路径'],
    image: 'https://readdy.ai/api/search-image?query=Elegant%20illustration%20of%20four%20ascending%20steps%20made%20of%20warm%20golden%20light%2C%20each%20step%20glowing%20brighter%2C%20representing%20growing%20trust%20in%20relationships%2C%20soft%20cream%20background%2C%20minimalist%20composition%2C%20editorial%20style%2C%20uplifting%20and%20warm%20atmosphere&width=800&height=600&seq=art-trust-building&orientation=landscape',
    date: '2026-06-08',
    readTime: '7 分钟',
    author: '姐姐的朋友编辑部',
  },
  {
    id: 'art-010',
    slug: 'neixiangzhe-shejiao-tuwei',
    title: '内向者的社交突围之道：用你的方式建立深度连接',
    excerpt: '社交不是外向者的专利。内向者拥有独特的社交优势，学会发挥这些优势，建立更有深度的人际关系。',
    content: [
      '在普遍的社交观念中，似乎外向者天生就占据优势。但实际上，内向者在社交中拥有许多被低估的独特优势。这篇文章为内向者提供一套专属的社交突围策略。',
      '首先，重新定义社交成功的标准。社交成功不是认识了多少人，而是建立了多少有质量的连接。内向者通常不擅长在大型社交场合中成为焦点，但在一对一的深入交谈中，内向者的倾听能力、共情能力和深度思考能力反而是巨大的优势。',
      '其次，选择适合你的社交场景。比起嘈杂的酒吧或大型派对，内向者更适合小型的聚餐、读书会、workshop等能够进行深入交流的场合。在这些场景中，你的社交优势更容易发挥。',
      '第三，利用"提前准备"的优势。内向者往往在社交前感到焦虑。你可以通过提前准备话题、了解参与者背景等方式来降低这种焦虑。不是所有"自然"的社交才是好的社交，有准备的社交同样真诚。',
      '第四，学会"战略性休息"。内向者在社交中容易能量消耗快。与其硬撑着笑脸到最后，不如学会在社交间隙给自己充电——去洗手间深呼吸几次，或者到安静的角落短暂休息。照顾好自己，才能在社交中展现最好的状态。',
      '最后，发挥你建立深度关系的能力。内向者往往是"少而精"的关系建立者。当你真正和一个人建立了连接，这段关系的深度和持久度往往超过外向者广泛但浅层的社交网络。',
    ],
    category: 'shejiao-xinlixue',
    categoryName: '社交心理学',
    tags: ['内向者', '社交突围', '深度连接', '社交策略'],
    image: 'https://readdy.ai/api/search-image?query=Elegant%20illustration%20of%20a%20single%20person%20reading%20quietly%20in%20a%20warm%20sunlit%20corner%2C%20surrounded%20by%20gentle%20glowing%20orbs%20representing%20meaningful%20connections%2C%20soft%20amber%20and%20cream%20tones%2C%20minimalist%20composition%2C%20editorial%20style%2C%20peaceful%20yet%20connected%20atmosphere&width=800&height=600&seq=art-introvert-social&orientation=landscape',
    date: '2026-06-01',
    readTime: '6 分钟',
    author: '姐姐的朋友编辑部',
  },
];

export const articleMap: Record<string, Article> = {};
articles.forEach((art) => {
  articleMap[art.slug] = art;
});

export function getArticlesByCategory(categorySlug: string): Article[] {
  return articles.filter((a) => a.category === categorySlug);
}

export function getRelatedArticles(currentSlug: string, category: string, count: number = 3): Article[] {
  return articles
    .filter((a) => a.category === category && a.slug !== currentSlug)
    .slice(0, count);
}